import React from 'react';
import { FormattedMessage } from 'react-intl';

import { DefaultError } from '../default-error/component';

export const NetworkError: React.FC = () => (
    <DefaultError
        mainText={
            <>
                <FormattedMessage
                    id="features.player.612f911df98dec7ce1fe2084c1c6fa05"
                    defaultMessage="Something's wrong with your internet connection."
                    description="Текст сетевой ошибки в плеере"
                />{' '}
                <FormattedMessage
                    id="features.player.13f6855489635d3927c8bf16b9ffce3d"
                    defaultMessage="Check your connection and refresh the page."
                    description="Текст сетевой ошибки в плеере"
                />
            </>
        }
    />
);
